import React from 'react';

const WaveMiniIcon = (): React.ReactElement => (
    <svg
        version="1.1"
        className="device-svg-icons"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 48 48"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19.5 24C19.5 21.5147 21.5147 19.5 24 19.5C26.4853 19.5 28.5 21.5147 28.5 24C28.5 26.4853 26.4853 28.5 24 28.5C21.5147 28.5 19.5 26.4853 19.5 24ZM24 22.5C23.1716 22.5 22.5 23.1716 22.5 24C22.5 24.8284 23.1716 25.5 24 25.5C24.8284 25.5 25.5 24.8284 25.5 24C25.5 23.1716 24.8284 22.5 24 22.5Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M24 10.5C16.5442 10.5 10.5 16.5442 10.5 24C10.5 30.5294 15.137 35.9792 21.2984 37.2299C22.1701 37.4069 23.0734 37.5 24 37.5C24.9266 37.5 25.8299 37.4069 26.7016 37.2299C32.863 35.9792 37.5 30.5294 37.5 24C37.5 16.5442 31.4558 10.5 24 10.5ZM7.5 24C7.5 14.8873 14.8873 7.5 24 7.5C33.1127 7.5 40.5 14.8873 40.5 24C40.5 31.9843 34.8304 38.641 27.2984 40.17C26.2314 40.3866 25.1282 40.5 24 40.5C22.8718 40.5 21.7686 40.3866 20.7016 40.17C13.1696 38.641 7.5 31.9843 7.5 24Z"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.04 31.2466C25.994 31.2553 25.9481 31.2656 25.9026 31.2775C25.1988 31.4615 24.4694 31.5431 23.737 31.5175C23.0047 31.4918 22.2828 31.3595 21.5935 31.1267C21.5489 31.1117 21.5039 31.0982 21.4586 31.0864C21.3654 31.062 21.2709 31.0445 21.176 31.0337C20.5116 30.9582 19.8337 31.2162 19.4945 31.8038C19.0833 32.5159 19.3248 33.4376 20.0879 33.744C20.2703 33.8172 20.4547 33.8853 20.6408 33.9482C20.7095 33.9713 20.7784 33.9938 20.8475 34.0156C21.7469 34.2987 22.6836 34.4604 23.6329 34.4936C24.5822 34.5268 25.528 34.4309 26.445 34.2114C26.5154 34.1945 26.5857 34.1769 26.6559 34.1586C26.8459 34.1089 27.0346 34.0539 27.2217 33.9935C28.0044 33.7412 28.3096 32.8387 27.9492 32.0995C27.6519 31.4897 26.9936 31.185 26.3256 31.2138C26.2302 31.2179 26.1347 31.2289 26.04 31.2466Z"
        />
    </svg>
);

export default WaveMiniIcon;
